import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=96bc2de8&scoped=true&"
import script from "./PageFooter.vue?vue&type=script&lang=ts&"
export * from "./PageFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=96bc2de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc2de8",
  null
  
)

export default component.exports